module.exports = __webpack_public_path__ + "static/media/car-date.99eda88c.svg";